// extracted by mini-css-extract-plugin
export default {"startTestButton":"SecurityTopic_startTestButton__2T1jO"};